import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";

interface MoreInfoDialogProps {
  visible: boolean;
  onHide: () => void;
  onConfirm: (reason: string) => Promise<void> | void;
}

/**
 * US2: flag a prospect as needing more information. A non-blank reason is
 * required (FR-011); the prospect's pipeline position is unchanged.
 */
const MoreInfoDialog: React.FC<MoreInfoDialogProps> = ({
  visible,
  onHide,
  onConfirm,
}) => {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const trimmed = reason.trim();

  const close = () => {
    setReason("");
    onHide();
  };

  const submit = async () => {
    if (!trimmed) return;
    setSubmitting(true);
    try {
      await onConfirm(trimmed);
      close();
    } finally {
      setSubmitting(false);
    }
  };

  const footer = (
    <div>
      <Button label="Cancel" text onClick={close} disabled={submitting} />
      <Button
        label="Flag for follow-up"
        icon="pi pi-flag"
        onClick={submit}
        disabled={!trimmed || submitting}
        loading={submitting}
      />
    </div>
  );

  return (
    <Dialog
      header="Mark as needing more info"
      visible={visible}
      onHide={close}
      footer={footer}
      style={{ width: "30rem" }}
    >
      <label htmlFor="more-info-reason" className="input-label">
        What's needed from this prospect? <span>*</span>
      </label>
      <InputTextarea
        id="more-info-reason"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        rows={4}
        className="w-full mt-2"
        autoResize
      />
    </Dialog>
  );
};

export default MoreInfoDialog;
